import {command, queryAll} from "../../utils/api";

const GET_REPORTING_TYPE_ASSOCIATIONS_URL = `${process.env.PUBLIC_URL}/api/v1/r/regulatoryReportingTypeAssociations`;

export const GET_REPORTING_TYPE_ASSOCIATIONS = "GET_REPORTING_TYPE_ASSOCIATIONS";
export const GET_REPORTING_TYPE_ASSOCIATIONS_COMPLETED = "GET_REPORTING_TYPE_ASSOCIATIONS_COMPLETED";
export const GET_REPORTING_TYPE_ASSOCIATIONS_FAILED = "GET_REPORTING_TYPE_ASSOCIATIONS_FAILED";

export function getReportingTypeAssociations(dispensaryId) {
  const filter = {
    where: {dispensaryId}
  };
  return queryAll(GET_REPORTING_TYPE_ASSOCIATIONS_URL, filter, GET_REPORTING_TYPE_ASSOCIATIONS, GET_REPORTING_TYPE_ASSOCIATIONS_COMPLETED,
    GET_REPORTING_TYPE_ASSOCIATIONS_FAILED);
}

const REPORTING_TYPE_ASSOCIATION_URL = `${process.env.PUBLIC_URL}/api/v1/regulatoryReportingTypeAssociation`;
export const ASSOCIATE_REPORTING_TYPE = 'ASSOCIATE_REPORTING_TYPE';
export const ASSOCIATE_REPORTING_TYPE_COMPLETED = 'ASSOCIATE_REPORTING_TYPE_COMPLETED';
export const ASSOCIATE_REPORTING_TYPE_FAILED = 'ASSOCIATE_REPORTING_TYPE_FAILED';
export const associateReportingType = command(REPORTING_TYPE_ASSOCIATION_URL + '/associateRegulatoryReportingType',
  ASSOCIATE_REPORTING_TYPE, ASSOCIATE_REPORTING_TYPE_COMPLETED, ASSOCIATE_REPORTING_TYPE_FAILED);



// WEBPACK FOOTER //
// ./src/Dispensary/RegulatoryReporting/actions.js